import loadable from '@loadable/component';

export const LazyCashFundPurchaseConfirmationWrapper = loadable(
  () => import(/* webpackChunkName: "content/cashfunds/purchase-confirmation" */ './CashFundPurchaseConfirmationWrapper'),
);
